import { Button, ButtonProps, Flex, Text, Icon } from "@chakra-ui/react";

export const ActionButton = (props: {
    onClick: (val: any) => void,
    icon: any,
    text: string,
    buttonProps?: ButtonProps
}) => {
    const { onClick, icon, text, buttonProps } = props
    return (
        <Button
            w="100%"
            variant="brand"
            onClick={onClick}
            h={'32px'}
            mt={{ base: "15px", md: "0px" }}
            mx={{ base: 'auto', md: "1%" }}
            {...buttonProps}
        >
            <Flex h="100%" w="100%" justifyContent={"center"}>
                <Icon as={icon} w="17px" h="17px" alignSelf='center' mr="4%" />
                <Text fontSize={{ base: '12px', lg: 'sm' }} alignSelf='center' whiteSpace={'pre-wrap'}>{text}</Text>
            </Flex>
        </Button>
    )
}